<template>
  <ob-admin-section
    :type="type"
    :xlsx="true"
    :relatedItems="relatedItems">
    <template slot="section-title">Sectiune Liste APL-uri</template>
    <template slot="toolbar-title">Baza de date Liste APL-uri</template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
// import ColectiiAPL from '@/components/ColectiiAPL'

export default {
  name: 'liste',
  components: {
    'ob-admin-section': AdminSection
    // 'ob-colectii-apl': ColectiiAPL
  },
  data: () => ({
    type: 'lists'
  }),
  computed: {
    relatedItems () {
      // return { clients: [] }
      return this.$store.getters['lists/relatedItems']
    }
  },
  created () {
    this.$store.dispatch('lists/setEventWatchers')
    this.$store.dispatch('lists/fetchHeaders')
  },
  mounted () {
    // maybe this is not the best option
    this.$store.dispatch('lists/fetchAllRelated', '')
  }
}
</script>

<style>

</style>
